<template>
  <div class="precision-drive-scene">
    <!-- 顶部宣传区域 -->
    <div class="top-banner">
      <div class="banner-content">
        <h2 v-if="industryTitle && industryTitle.title" v-html="industryTitle.title"></h2>
<!--        <h1 class="main-title">精密驱动应用场景</h1>-->
        <p class="desc" v-if="industryTitle && industryTitle.content" v-html="industryTitle.content"></p>
<!--        <div class="icon-list">-->
<!--          <div class="icon-item">-->
<!--            <img src="@/assets/img/zhuansu.png" alt="加载中..." />-->
<!--            <span>高转速</span>-->
<!--          </div>-->
<!--          <div class="icon-item">-->
<!--            <img src="@/assets/img/jingdu.png" alt="加载中..." />-->
<!--            <span>高精度</span>-->
<!--          </div>-->
<!--          <div class="icon-item">-->
<!--            <img src="@/assets/img/Union.png" alt="加载中..." />-->
<!--            <span>强工艺</span>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>

    <!-- 分类卡片展示区域 -->
    <div class="category-container">
      <div
        class="category-card"
        :class="{ 'category-card-active': dialogVisible && selectedCategoryId === item.id }"
        v-for="item in activeList"
        :key="item.id"
        @click="openCategoryModal(item)"
      >
        <div class="category-image-wrapper">
          <img
            v-if="item.pic"
            :src="$VUE_APP_BASE_API + item.pic"
            :alt="item.industryTypeTitle"
            class="category-image"
          />
          <div v-else class="category-image-placeholder">
<!--            <span>暂无图片</span>-->
          </div>
        </div>
        <div class="category-info">
          <div class="category-title">{{ item.industryTypeTitle }}</div>
        </div>
      </div>
    </div>

    <!-- 视频弹窗 -->
    <el-dialog
      :title="selectedCategoryTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleDialogClose"
      class="video-dialog"
    >
      <div slot="title" class="dialog-title-wrapper">
        <span>{{ selectedCategoryTitle }}</span>
        <el-button 
          v-if="selectedCategoryPdfUrl"
          type="primary" 
          size="small"
          @click="openCategoryPdf"
          class="pdf-button"
        >
          详情
        </el-button>
      </div>
      <div class="modal-video-container">
        <div
          class="modal-video-card"
          v-for="video in modalVideoList"
          :key="video.id"
          @click="goToDetail(video.id)"
        >
          <div class="modal-video-wrapper" @click.stop>
            <video
              :src="$VUE_APP_BASE_API + video.videoPath"
              class="modal-video-player"
              controls
              autoplay
              muted
              playsinline
            ></video>
          </div>
          <div class="modal-video-info">
            <div class="modal-video-title">{{ video.title }}</div>
            <div class="modal-video-content">{{ stripHtmlTags(video.content) }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {getIndustryList, getIndustryTypeList, getIndustryTitle} from "@/api/sysytem/homePage";

export default {
  name: 'industryApplications',
  data() {
    return {
      activeList: [],
      industryTitle: null,
      dialogVisible: false,
      modalVideoList: [],
      selectedCategoryTitle: '',
      selectedCategoryId: null,
      selectedCategoryPdfUrl: null
    }
  },
  mounted() {
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      // 获取行业应用标题
      getIndustryTitle().then(res=>{
        if(res && res.code === 200 && res.data) {
          this.industryTitle = res.data
        }
      })

      getIndustryTypeList().then(res=>{
        this.activeList = res.data
      })
    },
    openCategoryModal(category) {
      this.selectedCategoryTitle = category.industryTypeTitle
      this.selectedCategoryId = category.id
      this.selectedCategoryPdfUrl = category.pdfUrl || null
      this.dialogVisible = true
      // 加载该分类下的视频列表
      getIndustryList({ typeId: category.id }).then(resInfo => {
        this.modalVideoList = resInfo.data || []
      })
    },
    handleDialogClose() {
      this.dialogVisible = false
      this.modalVideoList = []
      this.selectedCategoryTitle = ''
      this.selectedCategoryId = null
      this.selectedCategoryPdfUrl = null
    },
    openCategoryPdf() {
      if (!this.selectedCategoryPdfUrl) {
        this.$message.warning('该分类暂无PDF文件')
        return
      }
      // 构建完整的PDF URL
      let pdfUrl = this.selectedCategoryPdfUrl
      // 如果pdfUrl不是完整URL（不以http://或https://开头），则拼接基础API地址
      if (!pdfUrl.startsWith('http://') && !pdfUrl.startsWith('https://')) {
        pdfUrl = this.$VUE_APP_BASE_API + pdfUrl
      }
      // 在新窗口打开PDF
      window.open(pdfUrl, '_blank')
    },
    stripHtmlTags(html) {
      if (!html) return '';
      return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').trim();
    },
    goToDetail(industryId) {
      this.$router.push(`/industryDetail/${industryId}`)
    }
  }
}
</script>

<style scoped>
.precision-drive-scene {
 /* width: 100%;!**!*/
  background-color: #000; /* 整体背景黑色，与设计匹配 */
  color: #fff;
  overflow: hidden;
}

/* 顶部宣传区域样式 */
.top-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  position: relative;
  width: 1920px;
  height: 360px;
  margin: auto;
  background-image: url("@/assets/img/hangyeyingyong.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.banner-content {
  /*max-width: 500px;*/
  width: calc(100% - 27px);
  height: 71px;
  padding-left: calc((min(100vw, 1920px) - 1165px) / 2 + 27px);
  padding-right: 0;
  padding-top: 96px;
  padding-bottom: 193px;
  max-width: 500px;
}
.title {
  font-size: 20px;
  margin: 0 0 8px;
  opacity: 0.8;
}
.main-title {
  font-size: 36px;
  margin: 0 0 16px;
  font-weight: bold;
}
.desc {
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 24px;
  opacity: 0.8;
}
.icon-list {
  display: flex;
  gap: 20px;
}
.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon-item img {
  height: 22px;
  width: 22px;
  margin-bottom: 8px;
}
.icon-item span {
  font-size: 14px;
}
.banner-img img {
  width: 400px; /* 根据实际调整 */
  height: auto;
  opacity: 0.8;
}
/* 分类卡片容器样式 */
.category-container {
  width: 1165px;
  margin: 40px auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
}

/* 分类卡片样式 */
.category-card {
  flex: 0 0 375px;
  width: 375px;
  max-width: 375px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #151516;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.15);
}

.category-card-active {
  opacity: 0.5;
}

.category-image-wrapper {
  width: 100%;
  height: 200px;
  position: relative;
  background-color: #000;
  overflow: hidden;
}

.category-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.category-card:hover .category-image {
  transform: scale(1.05);
}

.category-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1a1a1a;
  color: #666;
  font-size: 14px;
}

.category-info {
  padding: 20px 16px;
  background: #151516;
}

.category-title {
  font-weight: 700;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 弹窗视频容器样式 */
.modal-video-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px 0;
}

/* 弹窗视频卡片样式 */
.modal-video-card {
  flex: 0 0 calc((100% - 40px) / 3);
  width: calc((100% - 40px) / 3);
  max-width: calc((100% - 40px) / 3);
  border-radius: 8px;
  overflow: hidden;
  background-color: #151516;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}

.modal-video-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.15);
}

.modal-video-wrapper {
  width: 100%;
  height: 200px;
  position: relative;
  background-color: #000;
}

.modal-video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 弹窗视频信息区域样式 */
.modal-video-info {
  padding: 0 16px;
  background: #151516;
  min-height: 105px;
  padding-bottom: 15px;
}

.modal-video-title {
  font-weight: 700;
  padding-top: 10px;
  padding-bottom: 5px;
  font-size: 16px;
  color: #FFFFFF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-video-content {
  font-size: 14px;
  color: #FFFFFF;
  opacity: 0.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 弹窗样式 */
.video-dialog ::v-deep .el-dialog {
  background-color: #000;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.video-dialog ::v-deep .el-dialog__header {
  background-color: #151516;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px;
}

.dialog-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.pdf-button {
  background-color: #006BFF;
  border-color: #006BFF;
  color: #fff;
  margin-right: 40px;
}

.pdf-button:hover {
  background-color: #0056CC;
  border-color: #0056CC;
}

.video-dialog ::v-deep .el-dialog__title {
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 700;
}

.video-dialog ::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #FFFFFF;
  font-size: 24px;
}

.video-dialog ::v-deep .el-dialog__body {
  background-color: #000;
  padding: 20px;
}
/* 响应式布局调整 */
/* 屏幕宽度小于1920px时 */
@media (max-width: 1919px) {
  .top-banner {
    width: 100%;
    height: 360px;
  }

  .banner-content {
    padding-left: calc((min(100vw, 1920px) - 1165px) / 2 + 27px);
    padding-right: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
    /* text-align: center; */
    width: auto;
    height: auto;
  }
}

/* 屏幕宽度小于1200px时 */
@media (max-width: 1199px) {
  .category-container {
    width: 100%;
    padding: 0 15px;
    justify-content: flex-start;
    box-sizing: border-box;
  }

  .banner-content {
    padding-left: calc(15px + 27px);
  }

  .category-card {
    flex: 0 0 calc((100% - 20px) / 2) !important;
    width: calc((100% - 20px) / 2) !important;
    max-width: calc((100% - 20px) / 2) !important;
    box-sizing: border-box;
  }

  .modal-video-card {
    flex: 0 0 calc((100% - 20px) / 2) !important;
    width: calc((100% - 20px) / 2) !important;
    max-width: calc((100% - 20px) / 2) !important;
    box-sizing: border-box;
  }
}

/* 屏幕宽度小于992px时 */
@media (max-width: 991px) {
  .main-title {
    font-size: 28px;
  }

  .title {
    font-size: 18px;
  }
}

/* 屏幕宽度小于768px时 */
@media (max-width: 767px) {
  .category-container {
    padding: 0 15px;
    justify-content: center;
  }

  .banner-content {
    padding-left: calc(15px + 27px);
  }

  .category-card {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .modal-video-card {
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .video-dialog ::v-deep .el-dialog {
    width: 95% !important;
  }

  .main-title {
    font-size: 24px;
  }

  .desc {
    font-size: 14px;
  }
}

/* 屏幕宽度小于615px时 */
@media (max-width: 614px) {
  .category-container {
    justify-content: center;
  }
}
/* 屏幕宽度小于576px时 */
@media (max-width: 575px) {
  .category-container {
    padding: 0 15px;
  }

  .banner-content {
    padding-left: calc(15px + 27px);
  }

  .top-banner {
    padding: 40px 0;
  }

  .main-title {
    font-size: 20px;
  }

  .title {
    font-size: 16px;
  }

  .category-card {
    width: 100%;
  }

  .category-image-wrapper {
    height: 180px;
  }
}
</style>

